var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-9"},[_c('paper',[_c('task-form',{attrs:{"title":_vm.$t('tasks.form.title')},on:{"created":_vm.taskCreated}})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }